import { CRUDTable, TitledContainer } from 'components';

import { useGetRequest, useMemoState, usePatchRequest, usePostRequest } from 'hooks';
import { pushItemInArrayWithState, replaceItemInArrayWithState } from 'utils';

import { ClaimFeedback, ClaimFeedbackCreate, ClaimFeedbacks, ClaimFeedbackUpdate } from 'codegen';

import { useNoAccess } from './hooks';
import { columns, initTableActions } from './lib';

export const Feedbacks = () => {
  useNoAccess();

  const [feedbacks, setFeedbacks] = useMemoState<ClaimFeedback[]>([]);

  const { loading } = useGetRequest<ClaimFeedbacks>({
    url: '/claims/feedbacks',
    options: {
      onSuccess: ({ data }) => setFeedbacks(data.feedbacks),
    },
  });

  const [postFeedback, { loading: postLoading }] = usePostRequest<ClaimFeedback, ClaimFeedbackCreate>({
    url: '/claims/feedbacks',
    options: {
      onSuccess: ({ data }) => pushItemInArrayWithState(data, setFeedbacks),
    },
  });

  const [patchFeedback, { loading: patchLoading }] = usePatchRequest<ClaimFeedback, ClaimFeedbackUpdate>({
    options: {
      onSuccess: ({ data }) => replaceItemInArrayWithState(data, setFeedbacks),
    },
  });

  return (
    <TitledContainer title='Inquiry Feedback'>
      <CRUDTable
        verticalScroll
        id='inquiry-feedbacks'
        columns={columns}
        loading={loading || postLoading || patchLoading}
        dataSource={feedbacks}
        onPostTableData={(data) => postFeedback({ payload: data })}
        onPatchTableData={({ id, ...rest }) => patchFeedback({ callbackURL: `/claims/feedbacks/${id}`, payload: rest })}
        initialTableActions={initTableActions}
        addNewBtn={{ visible: true }}
      />
    </TitledContainer>
  );
};
